import React from "react";

// Paleta de estados (NUNCA dorado; el dorado es solo dato héroe + acción principal).
export const ESTADO = {
  critical: { color: "#D03B3B" },
  attention: { color: "#EC835A" },
  good: { color: "#0CA30C" },
  asleep: { color: "#D03B3B" },
};

// --- Formato de números (es-AR) ---
export const fmtInt = (n) => {
  const v = Math.round(Number(n) || 0);
  return v.toLocaleString("de-DE"); // punto como separador de miles
};
export const fmtUSD = (n) => `USD ${fmtInt(n)}`;
export const fmtPct = (x) => `${Math.round((Number(x) || 0) * 100)}%`;
export const fmtBrecha = (b) => {
  const v = Number(b) || 0;
  const signo = v > 0 ? "+" : v < 0 ? "−" : "";
  return `${signo}${Math.abs(v).toFixed(2).replace(".", ",")}`;
};
export const colorBrecha = (b) => ((Number(b) || 0) > 0.001 ? "#EC835A" : (Number(b) || 0) < -0.001 ? "#0CA30C" : "#6B6B6B");

export const inicialesDe = (nombre = "") => {
  const p = String(nombre).trim().split(/\s+/).filter(Boolean);
  if (p.length === 0) return "—";
  if (p.length === 1) return p[0].slice(0, 2).toUpperCase();
  return (p[0][0] + p[1][0]).toUpperCase();
};

export const haceCuanto = (iso) => {
  if (!iso) return "nunca";
  const d = Math.floor((Date.now() - new Date(iso).getTime()) / 86400000);
  if (d <= 0) return "hoy";
  if (d === 1) return "ayer";
  if (d < 30) return `hace ${d} días`;
  const m = Math.floor(d / 30);
  return m === 1 ? "hace 1 mes" : `hace ${m} meses`;
};

// --- Primitivas visuales ---
export function Card({ children, className = "", ...rest }) {
  return (
    <div
      className={`rounded-xl ${className}`}
      style={{ background: "#0F0F0F", border: "1px solid #1F1F1F" }}
      {...rest}
    >
      {children}
    </div>
  );
}

export function Avatar({ nombre, size = 36 }) {
  return (
    <div
      className="shrink-0 rounded-full flex items-center justify-center font-sans"
      style={{ width: size, height: size, background: "#161616", border: "1px solid #262626", color: "#C9C9C9", fontSize: size * 0.36, fontWeight: 500 }}
    >
      {inicialesDe(nombre)}
    </div>
  );
}

export function EstadoPunto({ estado }) {
  const c = ESTADO[estado?.key]?.color || "#6B6B6B";
  return (
    <span data-testid="estado-punto" className="inline-flex items-center gap-2 font-sans" style={{ fontSize: 13, color: "#C9C9C9" }}>
      <span data-testid="estado-punto-color" className="rounded-full" style={{ width: 8, height: 8, background: c, boxShadow: `0 0 8px ${c}66` }} />
      {estado?.label || "—"}
    </span>
  );
}

// Barra dual: atrás gris = tiempo transcurrido; adelante dorado = avance real.
export function BarraAvance({ avance = 0, tiempo = 0, height = 6 }) {
  const a = Math.max(0, Math.min(1, Number(avance) || 0));
  const t = Math.max(0, Math.min(1, Number(tiempo) || 0));
  return (
    <div className="relative w-full rounded-full overflow-hidden" style={{ height, background: "#161616" }}>
      <div className="absolute inset-y-0 left-0 rounded-full" style={{ width: `${t * 100}%`, background: "#2A2A2A" }} />
      <div className="absolute inset-y-0 left-0 rounded-full" style={{ width: `${a * 100}%`, background: "#C9A84C" }} />
    </div>
  );
}

// Sparkline SVG 60x20 sin ejes/grilla/números.
export function Sparkline({ data = [], width = 60, height = 20, color = "#C9A84C" }) {
  const vals = data.length ? data : [0];
  const max = Math.max(...vals, 1);
  const n = vals.length;
  const pad = 1.5;
  const pts = vals.map((v, i) => {
    const x = n === 1 ? width / 2 : pad + (i * (width - pad * 2)) / (n - 1);
    const y = height - pad - (v / max) * (height - pad * 2);
    return `${x.toFixed(1)},${y.toFixed(1)}`;
  }).join(" ");
  const vacio = vals.every((v) => !v);
  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} className="block">
      <polyline points={pts} fill="none" stroke={vacio ? "#2A2A2A" : color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

// Número héroe en Cormorant.
export function Hero({ children, size = 44, className = "" }) {
  return (
    <span className={`font-serif tracking-tight ${className}`} style={{ fontSize: size, lineHeight: 1, color: "#F5F0E8", fontVariantNumeric: "tabular-nums" }}>
      {children}
    </span>
  );
}

// Etiqueta chica en Inter (NUNCA mayúscula+spacing).
export function Etiqueta({ children, className = "" }) {
  return <span className={`font-sans ${className}`} style={{ fontSize: 12, fontWeight: 500, color: "#8A8A8A" }}>{children}</span>;
}

// Dato numérico en columna (mono + tabular).
export function Dato({ children, className = "", color = "#E8E8E8", ...rest }) {
  return <span className={`font-mono tabular-nums ${className}`} style={{ color }} {...rest}>{children}</span>;
}

export function EmptyState({ icon: Icon, titulo, sub }) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-14 px-6">
      {Icon && <Icon size={26} strokeWidth={1.4} style={{ color: "#5A5A5A" }} className="mb-4" />}
      <div className="font-serif" style={{ fontSize: 26, color: "#D8D2C6" }}>{titulo}</div>
      {sub && <div className="font-sans mt-2" style={{ fontSize: 13, color: "#7A7A7A" }}>{sub}</div>}
    </div>
  );
}
